var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddtask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2425_7606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 18.8333C9.34706 18.8333 8.26373 18.6145 7.24984 18.177C6.23595 17.7395 5.354 17.1458 4.604 16.3958C3.854 15.6458 3.26025 14.7638 2.82275 13.75C2.38525 12.7361 2.1665 11.6527 2.1665 10.5C2.1665 9.34718 2.38525 8.26385 2.82275 7.24996C3.26025 6.23607 3.854 5.35413 4.604 4.60413C5.354 3.85413 6.23595 3.26038 7.24984 2.82288C8.26373 2.38538 9.34706 2.16663 10.4998 2.16663C11.4026 2.16663 12.2568 2.29857 13.0623 2.56246C13.8679 2.82635 14.6109 3.1944 15.2915 3.66663L14.0832 4.89579C13.5554 4.56246 12.9929 4.30204 12.3957 4.11454C11.7984 3.92704 11.1665 3.83329 10.4998 3.83329C8.65262 3.83329 7.0797 4.4826 5.78109 5.78121C4.48248 7.07982 3.83317 8.65274 3.83317 10.5C3.83317 12.3472 4.48248 13.9201 5.78109 15.2187C7.0797 16.5173 8.65262 17.1666 10.4998 17.1666C10.9443 17.1666 11.3748 17.125 11.7915 17.0416C12.2082 16.9583 12.6109 16.8402 12.9998 16.6875L14.2498 17.9583C13.6804 18.2361 13.0832 18.4513 12.4582 18.6041C11.8332 18.7569 11.1804 18.8333 10.4998 18.8333ZM16.3332 17.1666V14.6666H13.8332V13H16.3332V10.5H17.9998V13H20.4998V14.6666H17.9998V17.1666H16.3332ZM9.33317 14.3333L5.7915 10.7916L6.95817 9.62496L9.33317 12L17.6665 3.64579L18.8332 4.81246L9.33317 14.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_7606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtask);
export default __webpack_public_path__ + "static/media/addtask.11603725d9c0efdab333dbcdaf690692.svg";
export { ForwardRef as ReactComponent };